import { render, staticRenderFns } from "./RecommendSetting.vue?vue&type=template&id=09b7a717&scoped=true"
import script from "./RecommendSetting.vue?vue&type=script&lang=js"
export * from "./RecommendSetting.vue?vue&type=script&lang=js"
import style0 from "./RecommendSetting.vue?vue&type=style&index=0&id=09b7a717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7a717",
  null
  
)

export default component.exports